module.exports = __webpack_public_path__ + "static/media/ManagementView.13c90ef8.less";


//////////////////
// WEBPACK FOOTER
// ./src/views/ManagementView/ManagementView.less
// module id = 3247
// module chunks = 0